export const GAME_QUESTION_COUNT = 15;
export const GAME_LEVEL_COUNT = 6;

/** Mode de partie : S = standard (compté), T = test (non enregistré). */
export const GAME_PLAY_MODES = {
  STANDARD: "standard",
  TEST: "test",
};

export function isGameTestPlayMode(playMode) {
  return playMode === GAME_PLAY_MODES.TEST;
}

export function getGameLevelDescription(level, { testPlay = false } = {}) {
  if (!testPlay) return level.description;
  if (level.id === 1) return "Le noyau actif uniquement.";
  if (level.id >= 2 && level.id <= GAME_LEVEL_COUNT) {
    return `Paquet ${level.id - 1} uniquement.`;
  }
  return level.description;
}

/** Découverte des niveaux 1 à 5, maîtrise des niveaux 1 à 4. */
export const MASTERY_DISCOVERY_TARGET = 0.9;
export const MASTERY_MASTERY_TARGET = 0.8;

/** Découverte du niveau 6, maîtrise des niveaux 5 et 6. */
export const MASTERY_STRICT_DISCOVERY_TARGET = 1;
export const MASTERY_STRICT_MASTERY_TARGET = 0.9;

export const MASTERY_MIN_GAME_COUNT = 3;
export const MASTERY_MIN_GRADE_SCORE = 0.72;

export function getMasteryThresholdsForLevel(levelId) {
  if (levelId === 6) {
    return {
      discovery: MASTERY_STRICT_DISCOVERY_TARGET,
      mastery: MASTERY_STRICT_MASTERY_TARGET,
    };
  }

  if (levelId === 5) {
    return {
      discovery: MASTERY_DISCOVERY_TARGET,
      mastery: MASTERY_STRICT_MASTERY_TARGET,
    };
  }

  return {
    discovery: MASTERY_DISCOVERY_TARGET,
    mastery: MASTERY_MASTERY_TARGET,
  };
}

export const GAME_LEVELS = [
  {
    id: 1,
    name: "Lecteur du dimanche",
    description: "Le noyau actif uniquement.",
    icon: "lvl1.webp",
  },
  {
    id: 2,
    name: "Cueilleur de lettres",
    description: "Noyau + 1er paquet.",
    icon: "lvl2.webp",
  },
  {
    id: 3,
    name: "Marque-page",
    description: "Noyau + paquets 1 et 2.",
    icon: "lvl3.webp",
  },
  {
    id: 4,
    name: "Croque-chapitre",
    description: "Noyau + paquets 1 à 3.",
    icon: "lvl4.webp",
  },
  {
    id: 5,
    name: "Ami des livres",
    description: "Noyau + les 4 paquets.",
    icon: "lvl5.webp",
  },
  {
    id: 6,
    name: "Rat de bibliothèques",
    description: "Tous les mots du registre.",
    icon: "lvl6.webp",
  },
];
